"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightPalette = void 0;
var colors_1 = require("@mui/material/colors");
exports.lightPalette = {
    mode: "light",
    primary: {
        main: "#3B0E3C",
        light: "#FAF1FA",
        dark: "#1E061F",
        contrastText: "#ffffff",
    },
    accent: {
        main: "#7C3F82",
        light: "#E4CCE6",
        dark: "#582D5C",
        contrastText: "#ffffff",
    },
    secondary: {
        main: "#C4291F",
        light: "#F6C9C5",
        dark: "#7A1710",
        contrastText: "#ffffff",
    },
    error: {
        main: "#D32F2F",
        light: "#F8D7D5",
        dark: "#9A0007",
        contrastText: "#ffffff",
    },
    warning: {
        main: "#9A6A00",
        light: "#F6E3B4",
        dark: "#6B4900",
        contrastText: "#ffffff",
    },
    info: {
        main: "#b7b7b7",
        light: "#CBE4F3",
        dark: "#0B4361",
        contrastText: "#ffffff",
    },
    success: {
        main: "#16794A",
        light: "#B7E4C7",
        dark: "#0D4E2F",
        contrastText: "#ffffff",
    },
    divider: "#9992A1",
    background: {
        default: "#F7F5F8",
        paper: "#FFFFFF",
    },
    text: {
        primary: colors_1.grey[800],
        secondary: colors_1.grey[700],
        disabled: colors_1.grey[500],
    },
};
//# sourceMappingURL=palette.js.map